import { useMemo } from "react";
import { OrganizationResourcesClient } from "@/features/credentials/api/organization-resources-client";

export function useOrganizationResourcesClient() {
  return useMemo(() => new OrganizationResourcesClient(), []);
}
